import { useState, useId } from 'react';
import Pagination from '../../../components/Pagination/Pagination';
import dayjs from 'dayjs';
import { useAiModuleList } from '../../../hooks/queries/aiQueries';
import { SkeletonTable } from '../../../components/Skeleton';

const AiModuleSelect = ({mode, selectedModule, setSelectedModule}) => {
  // 각 인스턴스마다 고유한 ID 생성 (radio name 충돌 방지)
  const radioGroupId = useId();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(4);
  const [sortBy, setSortBy] = useState('CreatedDate');
  const [sortOrder, setSortOrder] = useState('desc');

  const { data: aiModuleData, isLoading: isLoadingAiModule, error: errorAiModule } = useAiModuleList({
    Page: currentPage,
    PageSize: pageSize,
    OrderBy: sortBy,
    OrderDirection: sortOrder,
    AiModelType: mode === 'all' ? null : mode === 'demand' ? 'ChargingDemandPrediction' : mode === 'cbl' ? 'CblPrediction' : null,
  });



  const totalPagesModule = Math.ceil(aiModuleData?.Total / pageSize);


  const aiModelTypeConvert = (aiModelType) => {
    switch (aiModelType) {
      case 'ChargingDemandPrediction': return '충전량 예측 모델';
      case 'CblPrediction': return 'CBL 예측 모델';
      default: return aiModelType;
    }
  }

  
  return (
    <>
      <div className="ai-module-management-module-table w-full">
        <table className="primary-table w-full">
          <thead>
            <tr>
              <th width="40px"></th>
              <th>AI 모델 타입</th>
              <th>모듈명</th>
              <th>버전</th>
              <th>Base알고리즘</th>
              <th>생성일시</th>
            </tr>
          </thead>
          <tbody>
            {isLoadingAiModule ? (
              <SkeletonTable rows={4} cols={6} />
            ) : errorAiModule ? (
              <div className="error-message">데이터를 불러오는 중 오류가 발생했습니다.</div>
            ) : aiModuleData?.Items?.length > 0 ? (
              aiModuleData.Items.map((item) => (
                <tr key={item.AiModuleInfoSysId}>
                  <td>
                    <input 
                      type="radio" 
                      name={radioGroupId} 
                      value={item.AiModuleInfoSysId} 
                      checked={selectedModule?.AiModuleInfoSysId === item.AiModuleInfoSysId}  
                      onChange={() => setSelectedModule(item)} 
                    />
                  </td>
                  <td>
                    <span className={`status-badge unknown`}>
                      {aiModelTypeConvert(item.AiModelType)}
                    </span>
                  </td>
                  <td>{item.ModuleName || '-'}</td>
                  <td>{item.Version || '-'}</td>
                  <td>{item.OriginAiAlgorithm || '-'}</td>
                  <td>{dayjs(item.CreatedDate).format('YYYY-MM-DD HH:mm:ss') || '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">데이터가 없습니다.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center mt-5">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPagesModule}
          onPageChange={setCurrentPage}
          size="small"
        />
      </div>
    </>
  )
}

export default AiModuleSelect